export function sanitizeNewsHtml (html) {
  if (!html) return ''
  const parser = new DOMParser()
  const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html')
  const blockedTags = ['script', 'iframe', 'object', 'embed']
  blockedTags.forEach(tag => {
    Array.prototype.slice.call(doc.querySelectorAll(tag)).forEach(node => node.remove())
  })
  Array.prototype.slice.call(doc.querySelectorAll('*')).forEach(node => {
    Array.prototype.slice.call(node.attributes).forEach(attr => {
      const name = attr.name.toLowerCase()
      const value = attr.value || ''
      if (name.indexOf('on') === 0 || name === 'style' || name === 'href' || /javascript:/i.test(value)) {
        node.removeAttribute(attr.name)
      }
    })
  })
  return doc.body.firstChild ? doc.body.firstChild.innerHTML : ''
}
